{
	"cycleId": "Cycle ID",
	"shipmentDate": "Date",
	"plant": "Plant",
	"status": "Status",
	"co2Assured": "CO2 Assured (Buffer) on {{date}}",
	"assuranceSerialNumber": "Assurance serial number",
	"transactionId": "Transaction ID"
}
